<fin-dapi-included-product-heading
  class="block"
  [locationCodes]="[bound.departure.locationCode, bound.arrival.locationCode]"
  [locations]="locations"
>
  <fcom-chip class="ms-xsmall-l light-type">{{
    useCabinClass && bound.cabinClass
      ? ('travelClass.' + bound.cabinClass.toLowerCase() | finLocalization)
      : (bound.fareFamily?.name | titlecase)
  }}</fcom-chip>
</fin-dapi-included-product-heading>

<a
  [attr.aria-label]="'ariaLabels.newTab' | finLocalization"
  [attr.href]="
    bound.cabinClass === FinnairCabinClass.ECONOMY
      ? ('MMB.includedProducts.tickets.readMoreAboutEconomy.link.url' | finLocalization)
      : ('MMB.includedProducts.tickets.readMoreAboutBusiness.link.url' | finLocalization)
  "
  target="_blank"
  rel="noopener"
  class="block font-body-1 link ms-xsmall-l accommodate-icon"
>
  <ng-container *ngIf="bound.cabinClass === FinnairCabinClass.ECONOMY; else businessLinkText">
    {{ 'MMB.includedProducts.tickets.readMoreAboutEconomy.text' | finLocalization }}
  </ng-container>
  <fcom-icon name="external-tab" class="icon-small ms-xxsmall-b"></fcom-icon>
</a>

<ng-template #businessLinkText>
  {{ 'MMB.includedProducts.tickets.readMoreAboutBusiness.text' | finLocalization }}
</ng-template>
